import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

// Modal séparé
import CourseUnitModal from "./partials/CourseUnitModal";

import ImportCourseUnitModal from "./partials/ImportCourseUnitModal";

import {
    getCourseUnits as onGetCourseUnits,
    addNewCourseUnit as onAddNewCourseUnit,
    updateCourseUnit as onUpdateCourseUnit,
    deleteCourseUnit as onDeleteCourseUnit,

    getCourseComponents as onGetCourseComponents,
    getTeachers as onGetTeachers,
    getSemesters as onGetSemesters,

    resetCourseUnitLastActionSuccess as OnResetCourseUnitLastActionSuccess

} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";

import Select from "react-select";

import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const CourseUnit = () => {

    //meta title
    document.title = "Unités d'enseignements | CinzanEdu";

    const dispatch = useDispatch();
    
    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [courseUnit, setCourseUnit] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);
    const [loadingState, setLoadingState] = useState(true);

    const [modalOpen, setModalOpen] = useState(false);
    


 

    // Selector Course unit
    const CourseUnitProperties = createSelector(
        (state) => state.courseUnitReducer, 
        (courseUnitReducer) => ({
            courseUnits: courseUnitReducer.courseUnits,
            loading: courseUnitReducer.loading,
            lastActionSuccess: courseUnitReducer.lastActionSuccess
        })
    );

    const {courseUnits, loading, lastActionSuccess} = useSelector(CourseUnitProperties);
    const [isLoading, setLoading] = useState(loading);

    // Selector Teachers
    const TeacherProperties = createSelector(
        (state) => state.teacherReducer, 
        (teacherReducer) => ({
            teachers: teacherReducer.teachers,
            loading: teacherReducer.loading
        })
    );   
    const {teachers} = useSelector(TeacherProperties);


    // Selector semesters
    const SemesterProperties = createSelector(
        (state) => state.semesterReducer, 
        (semesterReducer) => ({
            semesters: semesterReducer.semesters,
            loading: semesterReducer.loading
        })
    );   
    const {semesters} = useSelector(SemesterProperties);

    // Selector course component
    const CourseComponentProperties = createSelector(
        (state) => state.courseComponentReducer, 
        (courseComponentReducer) => ({
            courseComponents: courseComponentReducer.courseComponents,
            loading: courseComponentReducer.loading
        })
    );

    const {courseComponents} = useSelector(CourseComponentProperties);



    // Chargement initial des données
    useEffect(() => {
        if (!courseUnits.length) dispatch(onGetCourseUnits());
        if (!teachers.length) dispatch(onGetTeachers());
        if (!semesters.length) dispatch(onGetSemesters());
        if (!courseComponents.length) dispatch(onGetCourseComponents());
        setLoadingState(loading);
    }, [dispatch, courseUnits.length, teachers.length, semesters.length, courseComponents.length,  loading]);
    

    /*
    useEffect(() => {
        if (courseUnits && !courseUnits.length) {
            dispatch(onGetCourseUnits());
        }
    }, [dispatch, courseUnits]);

    // On mounting
    useEffect(() => {
        
            if (teachers && !teachers.length) {
            dispatch(onGetTeachers());
        }

    }, [dispatch,    teachers]);

    //const [isLoading, setLoading] = useState(loading)

    useEffect(() => {
        if (courseComponents && !courseComponents.length) {
            dispatch(onGetCourseComponents());
        }
    }, [dispatch, courseComponents]);


    */




    // Ferme le modal en cas de success
    useEffect(() => {
        
    if (lastActionSuccess && modal) {
        toggle();
        setCourseUnit(null);
        dispatch(OnResetCourseUnitLastActionSuccess()); // action qui remet à false
    }
    }, [lastActionSuccess, modal, dispatch]);
    
    
    // Toggle modal
    const toggle = () => {
        setModal(!modal);
        if (modal) setCourseUnit(null);
    };
    
    // Créer nouvelle course unit
    const onClickNewCourseUnit = () => {
        setIsEdit(false);
        setCourseUnit(null);
        toggle();
    };
    
    // Edit course unit
    const handleCourseUnitClick = (courseUnit) => {
        setCourseUnit(courseUnit);
        setIsEdit(true);
        toggle();
        dispatch(OnResetCourseUnitLastActionSuccess()); // reset pour l’édition
    };
        
    // Delete course unit
    const onClickDelete = (courseUnit) => {
        setCourseUnit(courseUnit);
        setDeleteModal(true);
    };
    const handleDeleteCourseUnit = () => {
        if (courseUnit?.id) {
        dispatch(onDeleteCourseUnit(courseUnit));
        setDeleteModal(false);
        }
    };

    const handleSuccess = (data) => {
        console.log("Import réussi :", data);
        // ici tu peux recharger la liste des facultés si besoin
    };



    

    
        

    

  

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Titre",
                accessorKey: "title",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Code",
                accessorKey: "code",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Semestre",
                accessorKey: "semester.code",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Crédit",
                accessorKey: "credit",
                enableColumnFilter: false,
                enableSorting: true,
            },
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleCourseUnitClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="bx bx-notepad" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Moyenne
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleCourseUnitClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            

                            
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteCourseUnit}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Unités d'enseignement" breadcrumbItem="Liste des unités d'enseignement" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="d-flex gap-2">
                                                    <Button color="success" onClick={() => setModalOpen(true)}>
                                                        Importer un fichier
                                                    </Button>

                                                    <Link to="#!" onClick={onClickNewCourseUnit} className="btn btn-primary me-1">Ajouter une UE</Link>
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={courseUnits || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }

                    {/* Modal séparé */}
                    <CourseUnitModal
                        modal={modal}
                        toggle={toggle}
                        isEdit={isEdit}
                        courseUnit={courseUnit}
                        semesters={semesters}
                        courseComponents={courseComponents}
                        teachers={teachers}
                        onSubmit={(payload) => {
                        if (isEdit) {
                            dispatch(onUpdateCourseUnit(payload));
                        } else {
                            dispatch(onAddNewCourseUnit(payload));
                        }
                        //toggle(); // 🔹 Fermeture automatique après succès
                        }}
                    />


                </div>
            </div>
            <ToastContainer />

            <ImportCourseUnitModal
                isOpen={modalOpen}
                toggle={() => setModalOpen(!modalOpen)}
                onSuccess={handleSuccess}
            />
        </React.Fragment>
    );
}


export default CourseUnit;